import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { StoreInventory } from './model/StoreInventory';

export const useStoreBopisInventory = (
    id?: string,
    productId?: string,
    quantity?: number,
    enabled?: boolean,
): UseQueryResult<StoreInventory> =>
    useBffGet(
        id ? `/stores/${id}/inventory/bopis` : null,
        [...(productId ? [{ productId }] : []), ...(quantity ? [{ quantity }] : [])],
        [BffQueryKey.STORE_BOPIS_INVENTORY, id ?? '', productId ?? '', String(quantity || '')],
        {
            enabled,
            keepPreviousData: true,
            headers: {
                'Cache-Control': 'no-store',
            },
        },
    );
